import { Component } from "@angular/core";
import { HeaderComponent } from "@coreui/angular";

@Component({
    selector: 'app-header',
    templateUrl: './public-header.component.html',
    styleUrl: './public-header.component.scss'
})
export class PublicHeaderComponent {

    visible = false;

    constructor() {
    }

    toggleCollapse(): void {
        this.visible = !this.visible;
    }
}